class Intersections {
	private jsts: any;

	constructor() {
		this.jsts = require("jsts");
	}

	public getZonesIntersection(renderedZones: google.maps.Polygon[]) {
		const geometryFactory = new this.jsts.geom.GeometryFactory();
		const result = {
			intersection: null,
			zones: [] as any[]
		};
		let intersection: any;

		renderedZones.forEach((polygon, i) => {
			const zone = this.createJstsPolygon(geometryFactory, polygon);

			if (i === 0) {
				// first iteration, set start point
				result.intersection = zone;
				result.zones.push(renderedZones[i]);
			} else {
				// check intersection with previous result if it exists
				intersection =
					result.intersection &&
					(result.intersection as any).intersection(zone);

				if (!intersection || (intersection && intersection.isEmpty())) {
					// Do anything in this case
					// result.intersection = null;
				} else {
					result.intersection = intersection;
					result.zones.push(renderedZones[i]);
				}
			}
		});

		/*  const intersection = renderedZones.reduce((acc: any, polygon: google.maps.Polygon) => {
	  const zone = this.createJstsPolygon(geometryFactory, polygon);
	  return acc === null ? zone : acc.intersection(zone);
	}, null);

	if (!intersection || intersection.isEmpty()) {
	  console.log('Zones are not intersected');
	  return null;
	}

	return intersection;*/

		return result;
	}

	public createJstsPolygon(
		geometryFactory: any,
		polygon: google.maps.Polygon
	) {
		const path = polygon.getPath();
		const coordinates = path.getArray().map(coord => {
			return new this.jsts.geom.Coordinate(coord.lat(), coord.lng());
		});

		if (
			coordinates[0].compareTo(coordinates[coordinates.length - 1]) !== 0
		) {
			coordinates.push(coordinates[0]);
		}

		const shell = geometryFactory.createLinearRing(coordinates);

		return geometryFactory.createPolygon(shell);
	}

	public getIntersectionPolygon(intersection: any): google.maps.Polygon {
		return new google.maps.Polygon({
			paths: intersection.getCoordinates().map((coord: any) => {
				return { lat: coord.x, lng: coord.y };
			})
		});
	}

	public getRandomPointFromZoneCenter(
		zoneCenter: google.maps.LatLng,
		zone: google.maps.Polygon,
		map: google.maps.Map
	) {
		const paddings = [20, 10, 5, 1];
		const modifier = (Math.random() - 0.5) * 2;
		const overlay = new google.maps.OverlayView();

		overlay.setMap(map);

		const centerPoint = overlay
			.getProjection()
			.fromLatLngToContainerPixel(zoneCenter);
		let newPoint = null;
		let newPointCoords: any = null;

		paddings.forEach(padding => {
			if (!newPointCoords) {
				newPoint = new google.maps.Point(
					centerPoint.x + modifier * padding,
					centerPoint.y + modifier * padding
				);
				newPointCoords = overlay
					.getProjection()
					.fromContainerPixelToLatLng(newPoint);

				if (
					!google.maps.geometry.poly.containsLocation(
						newPointCoords,
						zone
					)
				) {
					newPointCoords = null;
				}
			}
		});

		if (!newPointCoords) {
			newPointCoords = zoneCenter;
		}

		return newPointCoords;
	}
}

const intersections = new Intersections();
export default intersections;
